import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/styles/PopularLocations.css";
import analyticsService from "../../services/analyticsService";

import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";

import BookingIcon from "../assets/img/Booklead.svg";
import Searchh from "../assets/img/Searchh.svg";
import ProjectVector from "../assets/img/projectVector.svg";
import LeadIcon from "../assets/img/registerlead.svg";
import locationadmin from "../assets/img/locationadmin.svg"
import arrowleftt from "../assets/img/arrowleftt.svg"

export default function PopularLocations() {
  const navigate = useNavigate();
  // EXACT React Native app state structure
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);
  const [states, setStates] = useState([]);
  const [citiesByState, setCitiesByState] = useState({});
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => { loadInitialData(); }, []);

  const loadInitialData = async () => {
    try {
      setLoading(true);
      const citiesStatesResponse = await analyticsService.getCitiesAndStates();
      if (citiesStatesResponse.success && citiesStatesResponse.data) {
        setStates([...new Set((citiesStatesResponse.data.states || []).map(s => s.replace(/\s+\d{5,6}\s*$/, '').trim()))].sort());
        setCitiesByState(citiesStatesResponse.data.citiesByState || {});
      }
      await loadLocations();
    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadLocations = async (pageNum = 1) => {
    try {
      const filters = { page: pageNum, per_page: 20 };
      if (selectedCity) filters.city = selectedCity;
      if (selectedState) filters.state = selectedState;
      const response = await analyticsService.getPopularLocations(filters);
      if (response.success && response.data) {
        setLocations(response.data.items || []);
        setTotal(response.data.total || 0);
        setTotalPages(response.data.total_pages || 1);
        setPage(pageNum);
      } else {
        setLocations([]); setTotal(0); setTotalPages(1); setPage(1);
      }
    } catch (error) {
      console.error('Error loading locations:', error);
      setLocations([]); setTotal(0); setTotalPages(1);
    }
  };

  const handleApply = async () => {
    setLoading(true);
    await loadLocations(1);
    setLoading(false);
  };

  const handleStateChange = (e) => { setSelectedState(e.target.value); setSelectedCity(''); };
  const handleCityChange = (e) => { setSelectedCity(e.target.value); };
  const getFilteredCities = () => !selectedState ? [] : (citiesByState[selectedState] || []);

  return (
    <div className="ploc-page d-flex">
      <LeftNav />

      <div className="ploc-content-wrap flex-grow-1">
        <TopNav />

        <div className="container-fluid">
          <div className="ploc-card card ploc-container-card mt-3">
            <div className="card-body">
              <div className="d-flex align-items-start justify-content-between ploc-header-row">
                <div className="d-flex align-items-center gap-2 ploc-header-left">
                   <img src={arrowleftt} onClick={() => navigate("/webadmindashboard")} style={{cursor: "pointer"}}></img>
                  <h2 className="ploc-page-title mb-0">Popular Locations</h2>
                </div>

                <div className="d-flex gap-2 align-items-end ploc-filters">
                  <div className="d-flex flex-column">
                    <label className="ploc-label">State</label>
                    <select
                      className="form-select form-select-sm ploc-select"
                      value={selectedState}
                      onChange={handleStateChange}
                      disabled={loading}
                    >
                      <option value="">Select State</option>
                      {Array.isArray(states) ? states.map((state, idx) => (
                        <option key={idx} value={state}>{state}</option>
                      )) : []}
                    </select>
                  </div>

                  {selectedState && (
                    <div className="d-flex flex-column">
                      <label className="ploc-label">City</label>
                      <select
                        className="form-select form-select-sm ploc-select"
                        value={selectedCity}
                        onChange={handleCityChange}
                        disabled={loading}
                      >
                        <option value="">Select City</option>
                        {getFilteredCities().map((city, idx) => (
                          <option key={idx} value={city}>{city}</option>
                        ))}
                      </select>
                    </div>
                  )}

                  <button
                    className="btn btn-primary ploc-apply-btn"
                    onClick={handleApply}
                    disabled={loading}
                  >
                    {loading ? 'Loading...' : 'Apply'}
                  </button>
                </div>
              </div>

              {/* Loading State */}
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="mt-3" style={{ color: '#888' }}>Loading...</div>
                </div>
              ) : locations.length === 0 ? (
                <div className="ploc-empty-container">
                  <p>No locations found</p>
                  <button onClick={handleApply} className="ploc-retry-btn">Retry</button>
                </div>
              ) : (
                <>
                  {/* grid with two columns like screenshot */}
                  <div className="ploc-grid mt-3">
                    {locations.map((location, idx) => {
                      const locationName = [location.city, location.state].filter(Boolean).join(', ');
                      const rank = (page - 1) * 20 + idx + 1;

                      return (
                        <div className="ploc-item card ploc-item-card" key={`${location.city}-${idx}`}>
                          <div className="ploc-item-body card-body">
                            <div className="d-flex align-items-start">
                              <div className="ploc-item-content flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start">
                                  <div className="ploc-title-wrap">
                                    <div className="ploc-location-title">
                                      {rank}  {locationName || 'Unknown Location'}
                                      <span className="ploc-location-pin">
                                        <img src={locationadmin} alt="Location" className="ploc-meta-icon" />
                                      </span>
                                    </div>
                                    <div className="border-lineee"> </div>
                                  </div>
                                </div>

                                <ul className="ploc-meta-grid">
                                  <li className="ploc-meta-cell">
                                    <span className="ploc-meta-left">
                                      <img src={BookingIcon} alt="Bookings" className="ploc-meta-icon" />
                                      <span className="ploc-meta-text">Total Bookings:</span>
                                    </span>
                                    <span className="ploc-meta-value">{location.total_bookings || 0}</span>
                                  </li>

                                  <li className="ploc-meta-cell">
                                    <span className="ploc-meta-left">
                                      <img src={Searchh} alt="Searches" className="ploc-meta-icon" />
                                      <span className="ploc-meta-text">Searches:</span>
                                    </span>
                                    <span className="ploc-meta-value">{location.searches || 0}</span>
                                  </li>

                                  <li className="ploc-meta-cell">
                                    <span className="ploc-meta-left">
                                      <img src={ProjectVector} alt="Project Leads" className="ploc-meta-icon" />
                                      <span className="ploc-meta-text">Project Leads:</span>
                                    </span>
                                    <span className="ploc-meta-value">{location.project_leads || 0}</span>
                                  </li>

                                  <li className="ploc-meta-cell">
                                    <span className="ploc-meta-left">
                                      <img src={LeadIcon} alt="Registered Leads" className="ploc-meta-icon" />
                                      <span className="ploc-meta-text">Registered Leads:</span>
                                    </span>
                                    <span className="ploc-meta-value">{location.registered_leads || 0}</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* Pagination (EXACT React Native app logic) */}
                  {totalPages > 1 && (
                    <div className="ploc-pagination">
                      <button
                        className={`ploc-page-btn ${page <= 1 ? 'disabled' : ''}`}
                        onClick={async () => {
                          if (page > 1 && !loading) {
                            setLoading(true);
                            try {
                              await loadLocations(page - 1);
                            } finally {
                              setLoading(false);
                            }
                          }
                        }}
                        disabled={page <= 1 || loading}
                      >
                        ← Previous
                      </button>

                      <span className="ploc-page-info">
                        Page {page} of {totalPages} ({total} total)
                      </span>

                      <button
                        className={`ploc-page-btn ${page >= totalPages ? 'disabled' : ''}`}
                        onClick={async () => {
                          if (page < totalPages && !loading) {
                            setLoading(true);
                            try {
                              await loadLocations(page + 1);
                            } finally {
                              setLoading(false);
                            }
                          }
                        }}
                        disabled={page >= totalPages || loading}
                      >
                        Next →
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}